import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { ModuleContext } from "../utils/Constants";
import { useSelector } from "react-redux";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";

export default function SaitRadioGroup(props) {
	const id = "RadioGroup-" + props.label;

	const componentModule = React.useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === props.objmod);

	const handleChange = (selectedIndex) => {
		let selectedOption = props.options[selectedIndex];
		props.onChange(selectedOption?.value || selectedOption?.operator || "NO_FILTER", selectedOption?.operator, selectedIndex);
	};

	return isComponentVisible(objMod, props.hidden) ? (
		<FormControl disabled={isComponentDisabled(objMod, props.disabled)}>
			<FormLabel id={id}>{props.label}</FormLabel>
			<RadioGroup row aria-labelledby={id} value={props.value}>
				{props.options?.map((radio, index) => (
					<FormControlLabel
						key={index}
						value={index}
						control={
							<Radio
								onClick={() => handleChange(index)} // Passa il valore e la chiave (indice)
							/>
						}
						label={radio.label}
					/>
				))}
			</RadioGroup>
		</FormControl>
	) : null;
}
